import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {AdminPanelService} from '../../../data/admin-panel.service';
import {MiscSnackBarService} from '../../../../../../../../core/src/lib/misc/view/snackbar/misc-snackbar.service';
import {PricingCategory} from '../../../../project-calc/data/pricing-category';
import {ProjectCalcService} from '../../../../project-calc/data/project-calc.service';
import {PricingMiscItem} from '../../../../project-calc/data/misc-item/pricing-misc-item';

@Component({
  selector: 'app-category-editor-dialog',
  templateUrl: './category-editor-dialog.component.html',
  styleUrls: ['./category-editor-dialog.component.scss']
})
export class CategoryEditorDialogComponent implements OnInit {
  saveLoading = false;
  deleteLoadingSpinner: boolean;

  footerBtnString = 'Add'

  tempCategory: PricingCategory

  miscItemLoading = true;

  miscItems: PricingMiscItem[]

  constructor(
    protected dialogRef: MatDialogRef<CategoryEditorDialogComponent>,
    protected adminPanelService: AdminPanelService,
    private miscSnackBarService: MiscSnackBarService,
    private projectCalcService: ProjectCalcService,
    private matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private data: {
      category: PricingCategory
    }
  ) {
    this.tempCategory = Object.assign({}, this.data.category)
    if (this.tempCategory.id) {
      this.footerBtnString = 'Save'
    }
  }

  ngOnInit(): void {
    this.getMiscItems();
  }


  saveCategory() {
    this.saveLoading = true;

    if (this.tempCategory.id) {
      this.adminPanelService.updateCategory(this.tempCategory).subscribe(res => {
        this.miscSnackBarService.openSuccessSnackBar('Success!')
        this.dialogRef.close(res)
      }, () => {
        this.saveLoading = false
      })
    } else {
      this.adminPanelService.createCategory(this.tempCategory).subscribe(res => {
        this.dialogRef.close(res)
      }, () => {
        this.saveLoading = false
      })
    }
  }


  deleteCategory() {
    this.deleteLoadingSpinner = true
    this.adminPanelService.deleteCategory(this.tempCategory.id).subscribe(() => {
      this.dialogRef.close('delete');
    }, () => {
      this.deleteLoadingSpinner = false
    })
  }

  closeDialog() {
    this.dialogRef.close('close-button');
  }


  getMiscItems() {
    this.projectCalcService.getMiscItems().subscribe(miscItems => {
      this.miscItems = miscItems
      this.miscItemLoading = false;
    }, () => {
      this.miscItemLoading = false;
    })
  }

}
